import { flow, isEmpty, join, reject, startCase } from 'lodash/fp';

export default flow(
  reject(isEmpty),
  join(' '),
  startCase
);
